import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chatbot-history',
  templateUrl: './chatbot-history.component.html',
  styleUrls: ['./chatbot-history.component.scss']
})
export class ChatbotHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
